const isNullishOrBlank = (value) =>
  value === undefined || value === null || String(value).trim() === "";

export default isNullishOrBlank;
